import moment from "moment";

export const formatUserActivityData = (userActivityLists) => {
    let data = [];
    let moduleName = {
        listen: "Listening",
        smr: "Response",
        smp: "Publishing",
        opa: "Page Analytics",
    };
    userActivityLists.forEach((userObj) => {
        let obj = {};
        obj.lite_id = userObj.lite_user_id;
        obj.name = userObj.user_full_name;
        obj.activity = getActivityContent(userObj.activity_type, userObj);
        obj.content = userObj.detail;
        obj.date = userObj.created_date;
        obj.priority = userObj.priority;
        obj.module = moduleName[userObj.module_name] || "Null";
        if (userObj.detail) data.push(obj); //if detail is not present(edge case), don't push it
    });

    return data;
};

export const getActivityContent = (activityType, data) => {
    let obj = {};
    return activityType;
};

export const getFiltersFromQueryParams = (query) => {
    const queryParamLists = new URLSearchParams(query);
    const params = {};
    // console.log(queryParamLists.size);
    queryParamLists.forEach((value, key) => {
        params[key] = value;
    });
    return { params };
};

export const getDateParams = (dateParams = {}) => {
    const tz = localStorage.company ? JSON.parse(localStorage.company).user_timezone_name : "";

    // console.log("dateParams", dateParams);
    const data = {
        start_date: dateParams.startDateTime || null,
        end_date: dateParams.endDateTime || null,
        ...dateParams,
    };

    const params = {};

    if (data.duration === "custom") {
        params.start_date = moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "24HRS") {
        params.end_date = moment().tz(tz).startOf("minute").format("YYYY-MM-DDTHH:mm:ss");
        params.start_date = moment().tz(tz).subtract(1, "day").startOf("minute").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastmonth") {
        params.start_date = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment().startOf("month").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastquarter") {
        params.start_date = moment().startOf("quarter").subtract(1, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment().startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "last2quarter") {
        params.start_date = moment().startOf("quarter").subtract(2, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment().startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else {
        params.end_date = moment().tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        params.start_date = moment()
            .tz(tz)
            .startOf("day")
            .subtract(data.duration - 1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.end_date = moment().tz(tz).format("YYYY-MM-DDTHH:mm:59");
    }
    return params;
};

export const getUserActivityLogsParams = (data = {}) => {
    const { offset = 0, pagination = false, filterRefineFilter, companyLiteId, durationFilter } = data;
    const userLists = filterRefineFilter?.users?.[0] === "selectAll" ? [] : [...(filterRefineFilter?.users || [])];
    const activityTypes = filterRefineFilter?.activityTypes?.[0] === "selectAll" ? [] : [...(filterRefineFilter?.activityTypes || [])];

    // const start_date = moment(duration.startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
    // const end_date = moment(duration.endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss");

    const { start_date, end_date } = getDateParams(durationFilter);
    const bodyParams = {
        lite_company_id: companyLiteId,
        priorities: ["high"],
        // env: "prod",
        records_per_page: 500,
        access_type: "write",
        start_date,
        end_date,
        pagination: pagination,
        offset: offset,
        // lite_user_id: +queryId || +userId,
        lite_user_ids: userLists,
        activity_groups: activityTypes,
    };
    const { duration, startDateTime, endDateTime, rollingDate } = durationFilter;

    const startDate = startDateTime ? moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss") : startDateTime;
    const endDate = endDateTime ? moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss") : endDateTime;

    window.history.replaceState(
        null,
        "",
        `settings/activity-logs?duration=${duration}&startDateTime=${startDate}&endDateTime=${endDate}&rollingDate=${rollingDate}&users=${userLists}&activityTypes=${activityTypes}`,
    );

    return bodyParams;
};

export const getActivityOptions = () => {
    return [
        { key: "all", text: "All", value: "selectAll" },

        {
            key: "account_management",
            value: "account_management",
            text: "Account Management",
        },
        {
            key: "administrator",
            value: "administrator",
            text: "Administrator",
        },
        // {
        //     key: "listen",
        //     value: "listen",
        //     text: "Listening",
        // },
        {
            key: "token_management",
            value: "token_management",
            text: "Token Details",
        },
        {
            key: "smr",
            value: "smr",
            text: "Social Media Response",
        },

        // {
        //     key: "smp",
        //     value: "smp",
        //     text: "Social Media Publishing",
        // },
    ];
};
